import { render, staticRenderFns } from "./Expeditions.vue?vue&type=template&id=5a433ad6&"
import script from "./Expeditions.vue?vue&type=script&lang=js&"
export * from "./Expeditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports